/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useEffect, useRef, useState } from 'react';
import storage from '../services/storage';
import { Link } from 'react-router-dom';
import { toggleBookMode } from '../Store/settings/siteSettings';
import searchImg from '../assets/images/search_icon.svg';
import arrowDown from '../assets/images/arrow-down.svg';
import arrowUp from '../assets/images/arrow-up.svg';
import textImg from '../assets/images/text.svg';
import teextImg from '../assets/images/teext.svg';
import Help from '../assets/images/help.svg';
import dashboard from '../assets/images/dashboard.svg';
import bellImg from '../assets/images/bell.svg';
import { byBook } from '../Store/api/activities';
import { show, single } from '../Store/api/books';
import { useDispatch, useSelector } from 'react-redux';
import { ProfileDropdown } from '../shared/ProfileDropdown';

const Header = ({
  book,
  setValue,
  dropdownWidth = '',
  searchBarWidth = '',
  handleClassSectionChange = () => {},
}) => {
  const classes = useSelector((state) => state.entities.classes);
  const [dropdownClass, setDropdownClass] = useState();
  const [dropdownSection, setDropdownSection] = useState();

  let sections = [];
  for (let index = 0; index < classes.classes.length; index++) {
    const element = classes.classes[index];
    sections = [...sections, ...element.sections.map((e) => e._id)];
  }
  const [user, setUser] = useState('');
  const [token, setToken] = useState('');
  const [isDropDownShown, setIsDropDownShown] = useState(false);
  const [chosenSections, setChosenSections] = useState([]);
  const [chosenClass, setChosenClass] = useState([]);
  const { settings } = useSelector((state) => state.settings.settings);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const [expandedClasses, setExpandedClasses] = useState([]); // To keep track of expanded classes

  const toggleClass = (classId) => {
    setExpandedClasses((prevExpandedClasses) =>
      prevExpandedClasses.includes(classId)
        ? prevExpandedClasses.filter((id) => id !== classId)
        : [...prevExpandedClasses, classId]
    );
  };

  useEffect(() => {
    handleClassSectionChange(chosenClass, chosenSections);
  }, [chosenClass, chosenSections]);

  useEffect(() => {
    if (classes?.classes?.length) {
      setTimeout(() => {
        const autoSelectClass = classes.classes.find((cls) => cls?.sections?.length === 1);
        if (autoSelectClass) {
          chooseClass(autoSelectClass._id, true); // Auto-select the class

          // Set dropdownClass and dropdownSection when auto-selecting
          setDropdownClass(autoSelectClass.courseNumber); // Set the class name
          setDropdownSection(
            `${autoSelectClass.sections[0].sectionName} ${autoSelectClass.sections[0].sectionNumber}`
          ); // Set the section name
        }
      }, 0); // Delay of 0 ms to let the page finish rendering
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classes?.classes?.length]);

  // Function to handle class selection
  const chooseClass = (classId, autoSelect = false) => {
    const classToToggle = classes?.classes?.find((cls) => cls._id === classId);

    // If no class found, return early
    if (!classToToggle) return;

    const allSectionIds = classToToggle.sections.map((section) => section._id);

    setChosenClass((prevChosenClass) => {
      const isClassChecked = prevChosenClass.includes(classId);
      const newChosenClass = isClassChecked
        ? prevChosenClass.filter((id) => id !== classId)
        : [...prevChosenClass, classId]; // Add or remove the class

      setChosenSections(
        (prevChosenSections) =>
          isClassChecked
            ? prevChosenSections.filter((id) => !allSectionIds.includes(id))
            : [...prevChosenSections, ...allSectionIds] // Add section IDs
      );

      // Set dropdownClass if manually selected or auto-selected
      setDropdownClass(classToToggle.courseNumber); // Set the class name

      if (autoSelect) {
      }

      return newChosenClass;
    });
  };

  // Function to handle section selection
  const chooseSection = (sectionId) => {
    const sectionToToggle = classes?.classes
      ?.flatMap((cls) => cls.sections)
      ?.find((section) => section._id === sectionId);

    setChosenSections((prevChosenSections) =>
      prevChosenSections.includes(sectionId)
        ? prevChosenSections.filter((id) => id !== sectionId)
        : [...prevChosenSections, sectionId]
    );

    // Set dropdownSection with the selected section's name

    setDropdownSection(`${sectionToToggle.sectionName} ${sectionToToggle.sectionNumber}`);
  };
  useEffect(() => {
    const Storeuser = storage.get('user');
    const Storetoken = storage.get('xAuthToken');
    setUser(Storeuser);
    setToken(Storetoken);
  }, [settings]);

  const toggle = () => {
    setIsDropDownShown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropDownShown(false); // Close the dropdown
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const renderClassList = (classList, type) => (
    <ul>
      {classList.map((el, index) => {
        const isCurrentClass = isWithinCurrentClassRange(el);
        const isUpcomingClass = isWithinUpcomingClassRange(el);

        if ((type === 'current' && isCurrentClass) || (type === 'upcoming' && isUpcomingClass)) {
          return renderClassItem(el, index);
        }

        return null;
      })}
    </ul>
  );

  const renderClassItem = (el, index) => (
    <Fragment key={index}>
      <div className='iagree_radio all-classes-select class-item-drop'>
        <div className='class-info-drop'>
          <input
            type='checkbox'
            checked={chosenClass.includes(el._id)} // This will reflect the updated state
            value={el._id}
            onChange={() => chooseClass(el._id)} // Manual selection
          />
          <label className=' squre-box drop_down_list' onClick={() => chooseClass(el._id)}>
            {el.courseNumber}
          </label>
          <img
            className='drop_down_list'
            style={{
              background: 'var(--Grey-100, #FAFAF9))',
            }}
            src={expandedClasses.includes(el._id) ? arrowUp : arrowDown}
            alt='arrow'
            onClick={() => toggleClass(el._id)}
          />
        </div>
        <div>
          <span
            className='f_12 view-book-drop'
            onClick={() => {
              setValue(true);

              if (book?._id === el?.book) return;
              dispatch(
                show({
                  id: el?.book,
                  onSuccess: (res) => {
                    dispatch(
                      single({
                        id: el?.book,
                        onSuccess: () => {
                          setValue(false);
                        },
                      })
                    );
                    dispatch(
                      byBook({
                        id: el?.book,
                        onSuccess: (res) => {},
                      })
                    );
                  },
                })
              );
              localStorage.setItem('lastBookId', el?.book);
            }}
          >
            VIEW BOOK
          </span>
        </div>
      </div>
      {expandedClasses.includes(el._id) && renderSectionList(el.sections)}
    </Fragment>
  );

  const renderSectionList = (sections) => (
    <ul className='sections-list'>
      {sections.map((section) => (
        <li key={section._id} className='section-item-drop'>
          <div
            className='iagree_radio section-info-drop'
            style={{ background: '#fff', fontWeight: '500' }}
          >
            <input
              type='checkbox'
              checked={chosenSections.includes(section._id)}
              value={section._id}
              onChange={() => chooseSection(section._id)}
            />

            <label
              style={{ fontWeight: '500' }}
              className='squre-box drop_down_list'
              onClick={() => chooseSection(section._id)}
            >
              {section.sectionName} {section.sectionNumber.split('-')[0]}
            </label>
          </div>
        </li>
      ))}
    </ul>
  );

  // Utility Functions
  const isWithinCurrentClassRange = (el) => {
    const today = new Date().setHours(0, 0, 0, 0);
    return (
      new Date(el.startDate).setHours(0, 0, 0, 0) <= today &&
      new Date(el.endDate).setHours(0, 0, 0, 0) >= today
    );
  };

  const isWithinUpcomingClassRange = (el) => {
    const today = new Date().setHours(0, 0, 0, 0);
    return (
      new Date(el.startDate).setHours(0, 0, 0, 0) > today &&
      new Date(el.endDate).setHours(0, 0, 0, 0) >= today
    );
  };

  return (
    <div
      className='row header-parent-padding'
      style={{
        // gap: "26px",
        justifyContent: 'space-between',
        '--bs-gutter-x': '0',
        '--bs-gutter-y': '0',
        padding: '0px 10px 0px 16px',
        // ...style,
      }}
    >
      <div className='col-xl-7 col-lg-12' style={{ width: '57%' }}>
        <div className='new_header_wrap'>
          <div className='search_wrap'>
            <div className='form-group search_input_wrap'>
              <input type='text' className='search_input' placeholder='Search in book' />{' '}
              <img
                src={searchImg}
                style={{ right: '0px' }}
                className='search_icon r-0 cursor'
                alt='search'
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className='col-xl-5 col-lg-12 '
        style={{ paddingLeft: '0px', width: dropdownWidth || '41%' }}
      >
        <div
          className='icon_with_student_button new_header_inner '
          style={{
            paddingTop: '12px',
            justifyContent: 'space-between',
          }}
        >
          <div className='d-flex align-items-center gap-4'>
            <a
              onClick={(e) => {
                e.preventDefault();
                if (settings.siteMode !== 'teach') return;
                dispatch(toggleBookMode());
              }}
            >
              <img
                src={settings.bookMode ? teextImg : textImg}
                alt='text'
                width={22}
                height={22}
                className='text_icon m-0 cursor'
              />
            </a>
            <a href='https://docs.greyled.com' target='_blank' rel='noreferrer'>
              <img src={Help} width={22} height={22} alt='Aa' className='text_icon m-0' />
            </a>
          </div>
          <div className='dropdown explore_btn' ref={dropdownRef} style={{ width: '53%' }}>
            <div className='form-group' onClick={toggle}>
              <div className='form_control w-100' style={{ height: 'auto' }}>
                <div className='select_class_parent d-flex justify-content-between w-100'>
                  <p
                    className='f_12 w-100 text-truncate-class'
                    title={
                      dropdownClass && dropdownSection
                        ? `${dropdownClass} | ${dropdownSection.split('-')[0]}`
                        : 'Class & Section Select'
                    }
                  >
                    {dropdownClass && dropdownSection
                      ? `${dropdownClass} | ${
                          dropdownSection.split('-')[0].length > 25
                            ? dropdownSection.split('-')[0].slice(0, 25) + '...'
                            : dropdownSection.split('-')[0]
                        }`
                      : 'Class & Section Select'}
                  </p>
                  <img
                    className='toggle_class_sel_arrow'
                    src={isDropDownShown ? arrowUp : arrowDown}
                    alt='arrow'
                  />
                </div>
              </div>
            </div>
            {isDropDownShown && (
              <div className='inner-option'>
                <p className='f13'>Assign to chosen sections</p>

                {sections.length > 0 && (
                  <>
                    <p className='f_12'>CURRENT CLASSES</p>
                    <div>{renderClassList(classes.classes, 'current')}</div>

                    <div className='horizontal-line'></div>

                    <p className='f_12'>UPCOMING CLASSES</p>
                    <div>{renderClassList(classes.classes, 'upcoming')}</div>
                  </>
                )}
              </div>
            )}
          </div>
          <div className='user_wrap d-flex align-items-center gap-4' style={{ marginLeft: '6px' }}>
            <Link
              to='/dashboard'
              className='cursor text-decoration-none'
              onClick={() => {
                localStorage.setItem('mode', 'assigned-mode');
              }}
            >
              <img
                src={dashboard}
                alt='dashboard'
                width={24}
                height={24}
                className='question cursor m-0'
              />
            </Link>
            <img src={bellImg} alt='bell' width={24} height={24} className='bell cursor m-0' />
            <div className='dropdown explore_btn cursor '>
              <ProfileDropdown user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
